<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div style="display: flex; justify-content: space-between; height: 50px">
        </div>
        <div class="card p-3">
          <h3> Скидки </h3>
          <transition name="fade" css="false"
                      @before-enter="beforeEnter"
                      @enter="enter"
                      @leave="leave">
            <div v-if="isLoading">
              <CircleProgress/>
            </div>
          </transition>

          <transition name="fade" css="false"
                      @before-enter="beforeEnter"
                      @enter="enter"
                      @leave="leave">
            <div v-if="!isLoading">
              <div
                  v-for="discount in discounts"
                  :key="discount.id"
                  class="card mb-3 p-3"
              >
                <div class="row align-items-center">
                  <div class="col-md-4">
                    <strong>{{ discount.days }} дней</strong>
                  </div>

                  <div class="col-md-4">
                    <argon-input
                        type="number"
                        v-model="discount.percent"
                        min="0"
                        max="100"
                    />
                  </div>

                  <div class="col-md-4 text-end">
                    <button
                        class="btn btn-primary"
                        @click="updateDiscount(discount)"
                        :disabled="discount.isSaving"
                    >
                      Сохранить
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "@/axios";
import CircleProgress from "./components/CircleProgress.vue";
import ArgonInput from "../components/ArgonInput.vue";
import velocity from "velocity-animate";
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

export default {
  name: "Discount",
  components: {
    CircleProgress,
    ArgonInput
  },
  data() {
    return {
      discounts: [],
      isLoading: false,
    };
  },
  methods: {
    fetchDiscounts() {
      this.isLoading = true;

      axios.get("/api/discount/list")
          .then(response => {
            this.discounts = response.data.map(item => ({
              ...item,
              isSaving: false
            }));
          })
          .finally(() => {
            this.isLoading = false;
          });
    },

    updateDiscount(discount) {
      discount.isSaving = true;

      axios.post(`/api/discount/update/${discount.id}`, {
        percent: discount.percent
      })
          .then(() => {
            // можно показать toast / alert
          })
          .catch(error => {
            console.error("Ошибка обновления:", error);
          })
          .finally(() => {
            discount.isSaving = false;
          });
    },

    beforeEnter(el) {
      el.style.opacity = 0;
    },
    enter(el, done) {
      velocity(el, {opacity: 1}, {duration: 300, complete: done});
    },
    leave(el, done) {
      velocity(el, {opacity: 0}, {duration: 300, complete: done});
    }
  },
  mounted() {
    this.fetchDiscounts();
  }
};
</script>
